import React, { useMemo, useState } from 'react';
import { parseISO, startOfMonth } from 'date-fns';
import { useStudio } from '../../contexts/StudioContext';
import { Draft } from '../../types/booking';
import { dayState, slotsForDate } from '../../utils/availability';
import { longDate, timeRange } from '../../utils/format';
import { MonthCalendar } from './MonthCalendar';
type Props = {
  draft: Draft;
  minutes: number;
  onChange: (patch: Partial<Draft>) => void;
};
export function StepWhen({
  draft,
  minutes,
  onChange
}: Props) {
  const {
    bookings,
    settings
  } = useStudio();
  const [month, setMonth] = useState<Date>(draft.date ? startOfMonth(parseISO(draft.date)) : startOfMonth(new Date()));
  const slots = useMemo(() => draft.date ? slotsForDate(draft.date, minutes, bookings, settings) : [], [draft.date, minutes, bookings, settings]);
  return <div className="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,300px)] lg:gap-8" data-id="element-483" data-mp="2uta4rtn89akp">
      <MonthCalendar month={month} onMonthChange={setMonth} selected={draft.date} onSelect={iso => onChange({
      date: iso,
      time: null
    })} stateFor={date => dayState(date, minutes, bookings, settings)} minMonth={new Date()} data-id="element-484" data-mp="2pu7b15cp6qs1" />

      <div data-id="element-485" data-mp="3v7d8fr6m4i7u">
        <h3 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-486" data-mp="3v6v0vyei2hkm">
          {draft.date ? longDate(draft.date) : 'Starttijd'}
        </h3>

        {draft.date ? slots.length > 0 ? <div className="mt-4 grid grid-cols-2 gap-2.5 lg:grid-cols-1" data-id="element-487" data-mp="7xye48c12es5">
              {slots.map(slot => {
          const selected = draft.time === slot.time;
          return <button key={slot.time} type="button" disabled={!slot.available} aria-pressed={selected} onClick={() => onChange({
            time: slot.time
          })} className={`rounded-xl border px-4 py-3.5 text-sm font-medium transition-colors duration-200 ease-smooth ${selected ? 'border-ember bg-ember text-void' : slot.available ? 'border-edge bg-carbon text-chalk hover:border-ember/50' : 'cursor-not-allowed border-edge/50 text-dim/40'}`} data-id="element-488" data-mp="hryoaom62a7q">
                    {slot.available || selected ? timeRange(slot.time, minutes) : slot.time}
                    {!slot.available && <span className="ml-2 text-[11px] uppercase tracking-[0.12em]" data-id="element-489" data-mp="2uijg8pg93163">
                        {slot.reason === 'full' ? 'vol' : slot.reason === 'past' ? 'te kort' : 'gesloten'}
                      </span>}
                  </button>;
        })}
            </div> : <p className="mt-4 rounded-xl border border-dashed border-edge px-5 py-6 text-sm text-dim" data-id="element-490" data-mp="3i9f2l71xt45y">
              Op deze dag is er geen ruimte voor deze behandeling. Kies een andere dag in de agenda.
            </p> : <p className="mt-4 rounded-xl border border-dashed border-edge px-5 py-6 text-sm text-dim" data-id="element-491" data-mp="5q2ytmigts19">
            Kies eerst een dag in de agenda. We tonen alleen tijden waar uw behandeling volledig in past.
          </p>}

        <p className="mt-5 text-xs leading-relaxed text-dim" data-id="element-492" data-mp="3ssxwm3gwhu6x">
          Uw behandeling duurt ongeveer {Math.round(minutes / 60)} uur. Wij plannen maximaal {settings.bays}{' '}
          voertuigen per moment, zodat er altijd iemand aan uw auto werkt.
        </p>
      </div>
    </div>;
}